export default Object.freeze({
  VER_EXAME: 'ver_exame',
  VER_PRESCRICAO: 'ver_prescricao',
});
